import React, {useEffect, useMemo, useState} from 'react';

import SearchIcon from '@material-ui/icons/Search';
import { Grid, Typography } from '@material-ui/core';
import { GridGrow } from '../../components/GridGrow';
import { VerticalCenter } from '../../components/VerticalCenter';
import { SortByDropDown, SortCatagories } from './Views/Components/SortByDropDown';
import { useIsMobile } from '../../components/Mui3WidthProvider';
import { RightSideInteractions } from './LibraryAssetActions/RightSideInteractions';
import { DesktopLibraryAssetTable } from './Views/Components/DesktopLibraryAssetTable';
import { RightDrawer } from './RightDrawer/RightDrawer';
import { useLibrary, useLibrarySearch } from './LibraryPage';
import { HorizontalCentered } from '../../components/HorizontalCentered';
import { MobileLibraryAssetTable } from './Views/Components/MobileLibraryAssetTable';
import { LibraryItem } from '../../entities/LibraryItem';
import { PageTitle } from '../../components/PageTitle';

interface Props {
}

const searchForText = (items:LibraryItem[], text:string) => {
    if(text.trimEnd().length === 0)
        return items;
    const query = text.replaceAll("\\", "");
    const searchRegex = new RegExp(query, "i")
    return items.filter(i => searchRegex.test(i.name));
}

export function LibrarySearch(props:Props) {
    const [sortBy, setSortBy] = useState<SortCatagories>("Last Modified");
    const isMobile = useIsMobile();

    const context = useLibrary();
    const searchContext = useLibrarySearch();

    const libraryItems = useMemo(() => searchForText(context.libraryItems, searchContext.searchValue), [searchContext.searchValue, context.libraryItems])
    const [focusedItemId, setFocusedItemId] = useState<string>();
    const focusedItem = useMemo(() => libraryItems.find(i => i.id === focusedItemId), [focusedItemId, libraryItems])

    useEffect(() => {
        console.log("LibrarySearch Rendered");
    });

    if(isMobile)
        return (
            <MobileLibraryAssetTable 
                items={libraryItems}
                focusedItem={focusedItem}
                setFocusedItemId={(id) => setFocusedItemId(id)}
            />
        )

    return (
        <>
        <PageTitle title="Sermon Maker - Search" />
        { isMobile
        ?
            <MobileLibraryAssetTable 
                items={libraryItems}
                focusedItem={focusedItem}
                setFocusedItemId={(id) => setFocusedItemId(id)}
            />
        :
            <div style={{height: "100%"}}>
                <Grid container style={{height: 45, borderBottom: "1px solid rgb(225, 225, 225)"}}>
                    <Grid container item md={8} lg={9}  alignItems="center">
                        <Grid item>
                            <Typography style={{ color: "#5f6368", fontSize: "18px", fontWeight: 500, fontFamily: "Roboto, Helvetica"}}>
                                Search
                            </Typography>
                        </Grid>
                        <GridGrow />
                        <Grid item>
                            <SortByDropDown
                                sortBy={sortBy}
                                sortPremiumContent={false}
                                handleSortByChange={(sort) => setSortBy(sort)}
                            />
                        </Grid>
                    </Grid>
                    <Grid container item md={4} lg={3} >
                        <GridGrow />
                        <Grid item>
                            <RightSideInteractions focusedItem={focusedItem} />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container style={{height: "calc(100% - 45px)"}}>
                    <Grid item md={8} lg={9} style={{height: "100%", overflowY: "auto"}}>
                    {libraryItems.length === 0
                    ?
                        <VerticalCenter>
                            <HorizontalCentered>
                                <HorizontalCentered>
                                    <SearchIcon style={{ width: "150px", height: "150px", color: "#CCC"}}/>
                                </HorizontalCentered>
                                <Typography 
                                    style={{ 
                                        fontFamily: "Roboto, Helvetica", fontSize: "12px", marginTop: "12px", color: "#5f6368"
                                }}
                                >No matches found for {searchContext.searchValue}. Please try again.</Typography>
                            </HorizontalCentered>
                        </VerticalCenter>
                    :
                        <DesktopLibraryAssetTable items={libraryItems} sortBy={sortBy} setFocusedItem={(id) => setFocusedItemId(id)} focusedItem={focusedItem} />
                    }
                    </Grid>
                    <Grid item md={4} lg={3} style={{height: "100%", borderLeft: "1px solid rgb(225, 225, 225)"}}>
                        <RightDrawer item={focusedItem} />
                    </Grid>
                </Grid>
            </div>
        }
        </>
    );
}